import keyMirror from 'keymirror';

export default keyMirror({
  GET_FILTERS_REQUEST: null,
  GET_FILTERS_SUCCESS: null,
  GET_FILTERS_FAILURE: null,
});



// WEBPACK FOOTER //
// ./src/api/filters/types.js